<script lang="ts" setup>
const props = defineProps<{
  eventRsvpActivityItems: {
    label: string;
    value: string;
  }[];
}>();

const emit = defineEmits<{
  (e: "onSelectedRsvpChange", event: Event): void;
}>();

const model = defineModel<string | null>("selectedRsvpActivity", {
  type: String,
  default: null,
});
</script>

<template>
  <ul
    class="gap-4 grid grid-cols-1 px-4 xs:grid-cols-2 sm:px-0"
  >
    <li
      v-for="item in props.eventRsvpActivityItems"
      :key="item.value"
      class="text-sm cursor-pointer size-full"
      :class="{
        'xs:last:col-span-2': props.eventRsvpActivityItems.length >= 2 && item.value === 'both',
      }"
    >
      <label
        :for="item.value"
        :aria-checked="model === item.value"
        class="px-2.5 py-1.5 gap-1.5 size-full relative text-primary-900 text-nowrap rounded-full inline-block bg-primary-200 hover:bg-primary-400/75 active:bg-primary-500/75 disabled:bg-primary-200 aria-disabled:bg-primary-30 focus-visible:bg-primary-400 focus-visible:text-primary-900 focus:outline-none aria-checked:bg-primary-400 aria-checked:text-primary-950 transition-colors duration-150"
      >
        <input
          :id="item.value"
          v-model="model"
          type="radio"
          :value="item.value"
          class="absolute -z-1 left-0 top-0 opacity-0"
          @change="emit('onSelectedRsvpChange', $event)"
        >

        {{ item.label.toUpperCase() }}
      </label>
    </li>
  </ul>
</template>
